export const TYPE_UPDATE_LOCATION_ON_GMB = 'LOCATION_GMB';
export const TYPE_UPDATE_LOCATION_PHONE = 'LOCATION_PHONE';
export const TYPE_UPDATE_LOCATION_STORE_CODE = 'LOCATION_STORE_CODE';
export const TYPE_UPDATE_LOCATION_LOCATION_NAME = 'LOCATION_LOCATION_NAME';
export const TYPE_UPDATE_LOCATION_URL = 'LOCATION_URL';
export const TYPE_UPDATE_LOCATION_DESCRIPTION = 'LOCATION_DESCRIPTION';
export const TYPE_UPDATE_LOCATION_REGULAR_HOUR = 'LOCATION_REGULAR_HOUR';
export const TYPE_UPDATE_LOCATION_SPECIAL_HOUR = 'LOCATION_SPECIAL_HOUR';
export const TYPE_UPDATE_LOCATION_MORE_HOUR = 'LOCATION_MORE_HOUR';
export const TYPE_UPDATE_LOCATION_LABELS = 'LOCATION_LABELS';
export const TYPE_UPDATE_LOCATION_OPEN_INFO = 'LOCATION_OPEN_INFO';
export const TYPE_UPDATE_LOCATION_ADDRESS = 'LOCATION_ADDRESS';
export const TYPE_UPDATE_LOCATION_ATTR_URL_MENU = 'LOCATION_ATTR_URL_MENU';
export const TYPE_UPDATE_LOCATION_ATTR_URL_ORDER_AHEAD = 'LOCATION_ATTR_URL_ORDER_AHEAD';
export const TYPE_UPDATE_LOCATION_ATTR_URL_RESERVATIONS = 'LOCATION_ATTR_URL_RESERVATIONS';
export const TYPE_UPDATE_LOCATION_ATTR_URL_APPOINTMENT = 'LOCATION_ATTR_URL_APPOINTMENT';
export const TYPE_UPDATE_LOCATION_ATTR_URL_INVENTORY_SEARCH = 'TYPE_UPDATE_LOCATION_ATTR_URL_INVENTORY_SEARCH';
export const TYPE_UPDATE_LOCATION_ATTRIBUTES = 'LOCATION_ATTRIBUTES';
export const TYPE_UPDATE_LOCATION_ATTR_URL = 'LOCATION_ATTR_URL';
export const TYPE_UPDATE_FOOD_MENU = 'TYPE_UPDATE_FOOD_MENU';
export const TYPE_CREATE_LOCAL_POST = 'TYPE_CREATE_LOCAL_POST';
export const TYPE_UPDATE_LOCAL_POST = 'TYPE_UPDATE_LOCAL_POST';
export const TYPE_DELETE_LOCAL_POST = 'TYPE_DELETE_LOCAL_POST';
export const TYPE_UPDATE_LOCATION_MEDIA = 'LOCATION_MEDIA';
export const TYPE_UPDATE_LOCATION_CATEGORIES = 'UPDATE_LOCATION_CATEGORIES';

export const STATUS_WAITING = 'WAITING';
export const STATUS_ERROR = 'ERROR';
export const STATUS_OK = 'OK';
export const STATUS_RUNNING = 'RUNNING';